import { render, staticRenderFns } from "./ProjectEditor.vue?vue&type=template&id=26ed6ff0&scoped=true&"
import script from "./ProjectEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ed6ff0",
  null
  
)

export default component.exports